/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { StyleSheet, View, Text } from "react-native";
import {
  BackButton,
  ProvenanceStepTitle,
  ProvenanceStepSubtitle,
  TabSection,
  ImageVideoGallery,
} from "../index";
import { useViewport } from "@vlinder-web/viewport-provider-react";
import {  ButtonV } from "../../components";
import { useTheme } from "../../../../providers/theme";
const is = require("is_js");


export const SignatureProvStep = (props: any) => {
const { colors } = useTheme();
const { bp, width } = useViewport();
const _getButtonStyle = () => {
  let _style: any = {};
  _style = {
    minWidth: bp === "xs" || "sm" ? width * 0.6 : "250px",
    maxWidth: bp === "xs" || "sm" ? width * 0.8 : "250px",
    backgroundColor: colors?.primaryDark,
  };

  return _style;
};
  //const { bp } = useViewport();
  console.log("SignatureProvStep props", props?.data);
  return (
    <View style={StyleSheet.flatten([styles.container])} >
      {props?.data && props?.data?.ProvStepTitle && (
        <ProvenanceStepTitle title={props?.data?.ProvDetailInfo?.title} />
      )}
      {props?.data && props?.data?.ProvStepTitle && (
        <ProvenanceStepSubtitle
          title={props?.data?.ProvDetailInfo?.subtitle}
        />
      )}

      <BackButton onBackPress={props?.onBackButtonPress} />

      {/* {props?.data && props?.data?.PROV_STEP_TITLE_CARD && (
                <div style={{ marginTop: "30px" }}>
                    <ProvStepTitleCard
                        title={props?.data?.PROV_STEP_TITLE_CARD?.title}
                        logo={props?.data?.PROV_STEP_TITLE_CARD?.logo}
                        extraInfo={props?.data?.PROV_STEP_TITLE_CARD?.extraInfo}
                    />
                </div>
            )} */}
      {/* {props?.data && props?.data?.CHIP_LIST && (
                <ChipList chipItems={props?.data?.CHIP_LIST?.chipItems} />
            )} */}
      {props?.data &&
        props?.data?.images &&
        Array.isArray(props?.data?.images) &&
        props?.data?.images.length > 0 && (
          <ImageVideoGallery images={props?.data?.images} />
        )}

      {props?.data && props?.data?.ProvDetailInfo && (
        <div style={{ paddingTop: "20px"}}>
          <TabSection
            // onListItemPress={_onListItemPress}

            // provStepTitleCardProps={BP?.ProvStepTitleCard}
            // chipListProps={BP?.ChipList}
            // provDetailInfoProps={BP?.ProvDetailInfo}
            // provInfoList={BP?.ProvDetailInfo?.provInfoList}
            // aboutProvInfo={BP?.ProvDetailInfo?.aboutProvInfo}
            // provStepHeading={BP?.ProvDetailInfo?.title}
            // provMapProps={BP?.provMapProps}

            provStepHeading={props?.data?.provenanceDetailInfo?.title}
            aboutProvInfo={props?.data?.provenanceDetailInfo?.aboutProvInfo}
            provInfoList={props?.data?.provenanceDetailInfo?.provInfoList}
            geoJson={props?.data?.provenanceDetailInfo?.provGeoJson}
            defaultCenter={props?.data?.provenanceDetailInfo?.defaultCenter}
            defaultZoom={props?.data?.provenanceDetailInfo?.defaultZoom}
            googleMapAPIKey={props?.data?.provenanceDetailInfo?.googleMapAPIKey}
            
            // geoJson={props?.data?.PROV_STEP_GEOJSON} //PROV_STEP_GEOJSON
            // defaultCenter={props?.data?.defaultCenter}
            //geoJson={BP?.provMapProps?.geojson}
            bp={bp}
          />          
           {props?.data?.credentialURL && (
              <div style={StyleSheet.flatten([styles.buttonContainerStyle])}>
                <ButtonV
                  buttonText={"Verify Signature on Blockchain"}
                  onClick={() => window.open(props?.data?.credentialURL)}
                  buttonStyle={StyleSheet.flatten([
                    styles?.buttonStyle,
                    _getButtonStyle(),
                  ])}
                />
              </div>
            )}            
        </div>
      )}     
      
      {/* {props?.data?.credentialURL &&
        is.not.empty(props?.data?.credentialURL) &&
        is.existy(props?.data?.credentialURL) &&
        is.url(props?.data?.credentialURL) && (
          <FabButton
            onFabClick={() => {
              window.open(`${props?.data?.credentialURL}`, "_blank");
            }}
          />
        )} */}
        
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    
    
    // flex: 1,
    // alignItems: 'center',
    // justifyContent: 'center',
    // paddingTop: 20,
  },
  buttonStyle: {
    marginTop: "10px",
    marginBottom: "20px",
  },
  buttonContainerStyle: {
    display: "flex",
    justifyContent: "center",
  },
});
